import React, { Component } from 'react';
import { TreeLayer, TreeNodeProps } from '../../../atoms/tree-layer';
import { FolderView } from './folder-view';

type RootNodeProps = {
	className?: string;
} & TreeNodeProps<undefined>;

export class RootNode extends Component<RootNodeProps> {
	static defaultProps = {
		depth: 0,
	};

	render() {
		const { node, depth, getTreeNodeComponent } = this.props;

		if (!node.children) return null;

		return (
			<FolderView {...this.props} isOpen={true} Title={null}>
				<TreeLayer<undefined>
					childNodes={node.children}
					depth={depth - 1}
					getTreeNodeComponent={getTreeNodeComponent}
				/>
			</FolderView>
		);
	}
}
